import axiosIns from '../../../../xaxios';
import {  obtenerUrlAPICalificaciones } from '../utils/funciones';
/**
 * @typedef {import('../interfaces/solicitud-modificacion-calificacion.Interfaces').FiltrosSolicitudesInterface} FiltrosSolicitudesInterface
 */
const recurso = 'programas';

export default {

  async buscarProgramas(dataInput) {
    // console.log('filtros servicio', filtros);
    // eslint-disable-next-line no-console
    const {q} = dataInput;
    return await axiosIns.get(obtenerUrlAPICalificaciones(`${recurso}/portal?q=${q}`));
  },

};
